<template>
    <div>
        <OverlayModal
            closeText="Close"
            @modalClosed="closeModal">

            <div class="dashboard-view">
                <UserComments :userId="userId" @commentsNumChanged="commentsNumChanged" />
            </div>

        </OverlayModal>
    </div>
</template>

<script>
import OverlayModal from '@/components/global/OverlayModal'
import UserComments from "@/components/global/UserComments.vue";

export default {
    name: 'CommentsModal',
    props: ['userId'],
    components: {
        UserComments,
        OverlayModal
    },
    data: function() {
        return {
            changedCommentsNum: 0
        }
    },
    created() {

    },
    watch: {

    },
    methods: {
        commentsNumChanged(val) {
              this.changedCommentsNum = val
        },
        closeModal() {
            this.$emit('modalClosed', this.changedCommentsNum)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
